<template>
  <div id="fixed-point-cameras-layer">
  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";

// Store
const {
  mapActions: mapActionsOfLiveMap,
  mapMutations: mapMutationsOfLiveMap,
  mapState: mapStateOfLiveMap,
} = createNamespacedHelpers("liveMap");


export default {
  name: "FixedPointCamerasLayer",
  data() {
    return {
      selectedCameraId: null,
      collection : null,
      pulsing:null,
      layersMinZoom: 5,
      fixedPointCamerasPulsingImageId: "fixedPointCamerasPulsingImageId",
      fixedPointCamerasPulsingSourceId:"fixedPointCamerasPulsingSourceId",
      fixedPointCamerasPulsingLayerId: "fixedPointCamerasPulsingLayerId",
      fixedPointCamerasSourceId: "fixedPointCamerasSource",
      fixedPointCamerasLayerId: "fixedPointCamerasLayer",
      heavyEquipmentPinAttentionIcon: require("@/assets/images/vehicles/heavy_pin_attention.svg"),
    };
  },
  props: {
    map: Object,
    isReady: {type: Boolean, default: false},
    mapEvent: String
  },
  watch: {
    mapEvent() {
    },
    async isReady() {
      if (this.isReady) {
        this.createPulsing(this.map);
        await this.setMapSource();
        await this.setMapLayer();
        await this.setLayerEvent();
      }
    },
    selectedFixedPointCamera(val) {
      if(val === null) {
        for (let i = 0; i < this.collection.features.length; i++){
          this.collection.features[i].properties.icon = "fixed-point-camera-unselected";
          this.map.getSource(this.fixedPointCamerasSourceId).setData(this.collection);
          this.map.getSource(this.fixedPointCamerasPulsingSourceId).setData({
            type: "FeatureCollection",
            features: []
          });
        }
      }
    }
  },
  computed: {
    ...mapStateOfLiveMap({
      selectedFixedPointCamera: state => state.selectedFixedPointCamera,
      unsubscribes: state => state.unsubscribes
    })
  },
  methods: {
    ...mapActionsOfLiveMap(["fetchFixedPointCameras", "cleanUpPlotDetail"]),
    ...mapMutationsOfLiveMap([
      "SET_SELECTED_FIXED_POINT_CAMERA",
      "SET_SHOW_VESSEL_DETAIL",
      "SET_UNSUBSCRIBES"
    ]),

    async setMapSource() {
      this.map.addSource(this.fixedPointCamerasPulsingSourceId, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: []
        }
      });

      let data = await this.fetchFixedPointCameras();
      this.map.addSource(this.fixedPointCamerasSourceId, {
        type: "geojson",
        data: data
      });
      this.collection  = data
    },

    async setMapLayer() {
      this.map.addImage(this.fixedPointCamerasPulsingImageId, this.pulsing, { pixelRatio: 2 });
      this.map.addLayer({
        id: this.fixedPointCamerasPulsingLayerId,
        type: "symbol",
        minzoom: this.layersMinZoom,
        source: this.fixedPointCamerasPulsingSourceId,
        layout: {
          "icon-allow-overlap": true,
          "icon-ignore-placement": true,
          "icon-image": this.fixedPointCamerasPulsingImageId,
        }
      });

      this.map.addLayer({
        id: this.fixedPointCamerasLayerId,
        type: "symbol",
        minzoom: this.layersMinZoom,
        source: this.fixedPointCamerasSourceId,
        layout: {
          "icon-allow-overlap": true,
          "icon-pitch-alignment": "map",
          "icon-rotation-alignment": "map",
          "icon-image":  "{icon}",
          "icon-rotate": {
            type: "identity",
            property: "direction"
          },
          "text-field": "{name}",
          "text-size": 12,
          "text-offset": [
            "case",
            ["boolean", ['get', 'isTextTop'], true],
            ["literal", [0, -2]],
            ["literal", [0, 2]]
          ]
        },
        paint: {
          "text-color": "#FFFFFF",
          "text-halo-color": "#000000",
          "text-halo-width": 1
        }
      });
    },

    setLayerEvent() {
      let self = this

      this.map.on('click', this.fixedPointCamerasLayerId, (e) => {
        if(e.originalEvent.cancelBubble){
          return;
        }

        this.cleanOtherDetails()

        let cameraId = e.features[0].properties.cameraId
        let cameraType = e.features[0].properties.cameraType
        let cameraInfo = {
          cameraId:cameraId,
          cameraType:cameraType
        }

        if(this.selectedFixedPointCamera === null) {
          this.SET_SELECTED_FIXED_POINT_CAMERA(cameraInfo)
          this.setCollectionData(cameraId)
        } else {
          if(cameraId === this.selectedFixedPointCamera.cameraId) {
            return
          }
          this.SET_SELECTED_FIXED_POINT_CAMERA(null)
          const func = cameraInfo => {
            self.SET_SELECTED_FIXED_POINT_CAMERA(cameraInfo);
            self.setCollectionData(cameraId)
          };
          setTimeout(func.bind(undefined, cameraInfo), 500)
        }

      })

      this.map.on('mouseenter', this.fixedPointCamerasLayerId, function () {
        self.map.getCanvas().style.cursor = 'pointer';
      });

      this.map.on('mouseleave', this.fixedPointCamerasLayerId, function () {
        self.map.getCanvas().style.cursor = '';
      });
    },

    setCollectionData(cameraId) {
      let feature;
      for (let i = 0; i < this.collection.features.length; i++){
        if(cameraId === this.collection.features[i].properties.cameraId) {
          this.collection.features[i].properties.icon = "fixed-point-camera-selected";
          feature = this.collection.features[i]
        } else {
          this.collection.features[i].properties.icon = "fixed-point-camera-unselected";
        }
      }
      this.map.getSource(this.fixedPointCamerasSourceId).setData(this.collection);
      this.map.getSource(this.fixedPointCamerasPulsingSourceId).setData({
        type: "FeatureCollection",
        features: [feature]
      });
    },

    async cleanOtherDetails() {
      this.SET_SHOW_VESSEL_DETAIL(false);
      if (this.unsubscribes.length !== 0) {
        this.unsubscribes.forEach(unsubscribe => unsubscribe());
        this.SET_UNSUBSCRIBES([])
      }
      await this.cleanUpPlotDetail();

    },

    createPulsing(map) {
      let size = 100;
      this.pulsing = {
        width: size,
        height: size,
        data: new Uint8Array(size * size * 4),
        onAdd: function () {
          let canvas = document.createElement("canvas");
          canvas.width = this.width;
          canvas.height = this.height;
          this.context = canvas.getContext("2d");
        },

        render: function () {
          let duration = 3000;
          let t = (performance.now() % duration) / duration;

          let radius = (size / 2) * 0.3;
          let outerRadius = (size / 2) * 0.7 * t + radius;
          let context = this.context;

          context.clearRect(0, 0, this.width, this.height);
          context.beginPath();
          context.arc(
            this.width / 2,
            this.height / 2,
            outerRadius,
            0,
            Math.PI * 2
          );
          context.fillStyle = "rgba(255, 255, 255," + (1 - t) + ")";
          context.fill();

          // draw inner circle
          context.beginPath();
          context.arc(this.width / 2, this.height / 2, radius, 0, Math.PI * 2);
          context.fillStyle = "rgba(255, 255, 255, 0.4)";
          context.strokeStyle = "#FFFFFF";
          context.lineWidth = 2 + 4 * (1 - t);
          context.fill();
          context.stroke();

          this.data = context.getImageData(0, 0, this.width, this.height).data;

          map.triggerRepaint();

          return true;
        }
      };
    }
  },


}
</script>

<style scoped>

</style>
